import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../AccountSettings.scss';

const CARD_COUNT = 3;

/** Placeholder with the page's layout, shown while the signed-in user loads. */
function AccountSettingsSkeleton() {
  return (
    <div
      className='account-settings-page'
      aria-busy='true'
      aria-label='Loading account settings'
    >
      <div className='account-settings-layout'>
        <div className='account-settings-main'>
          <div className='account-settings-header'>
            <Skeleton
              width={220}
              height={28}
            />
            <Skeleton
              width={300}
              height={14}
            />
          </div>
          <div className='account-settings-content'>
            {Array.from({ length: CARD_COUNT }, (_, index) => (
              <div
                // biome-ignore lint/suspicious/noArrayIndexKey: static placeholders
                key={index}
                className='account-settings-card'
              >
                <Skeleton
                  width={160}
                  height={18}
                />
                <Skeleton height={14} />
                <Skeleton
                  width={120}
                  height={36}
                  borderRadius={10}
                />
              </div>
            ))}
          </div>
        </div>
        <div className='account-settings-sidebar'>
          <Skeleton
            height={96}
            borderRadius={10}
          />
        </div>
      </div>
    </div>
  );
}

AccountSettingsSkeleton.displayName = 'AccountSettingsSkeleton';
export default AccountSettingsSkeleton;
